module.exports = __webpack_public_path__ + "static/img/platform-bg-4.6fea5d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/platform-bg-4.png
// module id = +oe+
// module chunks = 1